import { gql } from '@apollo/client';

export const GET_MATCHING_CONFIG_ITEM = gql`
  query GetMatchingConfigItem($key: String) {
    vm {
      configItem(key: $key) {
        configItemId
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_MATCHING_SETTINGS = gql`
  query GetMatchingSettings {
    vm {
      matchingRules {
        matchingRuleId
        name
        enabled
        ruleOrder
        matchOnAvailability
        minimumScore
        action
        actionScheduling
        actionFrequency
        actionDurationMonths
        applicantRole {
          activityRoleId
          name
        }
        counterpartRole {
          activityRoleId
          name
        }
        program {
          programId
          name
        }
        sessions {
          matchingRuleSessionId
          name
          isFlexible
          position
          reportType {
            reportTypeId
            name
          }
        }
      }
      activityRoles {
        activityRoleId
        name
      }
      programs {
        programId
        name
      }
      reportTypes {
        reportTypeId
        name
      }
    }
  }
`;
